import Icon from '../components/Icon.vue'

Icon.register({"binoculars":{"width":512,"height":512,"paths":[{"d":"M416 48C416 39.2 408.8 32 400 32H336C327.2 32 320 39.2 320 48V96H416V48zM63.9 160C61.4 253.8 3.5 274.2 0 404V448C0 465.7 14.3 480 32 480H128C145.7 480 160 465.7 160 448V288H192V128H95.8C78.2 128 64.4 142.4 63.9 160zM448.1 160C447.6 142.4 433.8 128 416.2 128H320V288H352V448C352 465.7 366.3 480 384 480H480C497.7 480 512 465.7 512 448V404C508.5 274.2 450.6 253.8 448.1 160zM176 32H112C103.2 32 96 39.2 96 48V96H192V48C192 39.2 184.8 32 176 32zM224 288H288V128H224V288z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/binoculars.js
// module id = null
// module chunks = 